import React from 'react';
import PropTypes from 'prop-types';
import { sidebarStatePropType } from 'components/Sidebar/propTypes';
import { QUESTION_VIEW_TYPES } from '../constants/questionViewTypes';
import { MultipleOptionQuestionView } from './MultipleOptionQuestionView';

const { MULTISELECT_WITH_SEARCH } = QUESTION_VIEW_TYPES;

export const MultipleOptionQuestion = ({
  question, sidebarState, value, onChange, shouldNextButtonBeShown, handleNextButtonClick,
}) => {
  const {
    id, title, subtitle, placeholder, viewType = MULTISELECT_WITH_SEARCH, questionProps,
  } = question;

  return (
    <MultipleOptionQuestionView
      id={id}
      values={value ?? []}
      onChange={onChange}
      title={title}
      subtitle={subtitle}
      dropDownOptions={question.options?.dropDownOptions}
      radioOptions={question.options?.radioOptions}
      placeholder={placeholder}
      sidebarState={sidebarState}
      viewType={viewType}
      questionProps={questionProps}
      shouldNextButtonBeShown={shouldNextButtonBeShown}
      handleNextButtonClick={handleNextButtonClick}
    />
  );
};

MultipleOptionQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  sidebarState: sidebarStatePropType,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
  shouldNextButtonBeShown: PropTypes.bool.isRequired,
  handleNextButtonClick: PropTypes.func.isRequired,
};
